import styled from 'styled-components';

export const SSemiFixedContainer = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`;
export const SFixed = styled.div`
  flex: 0 0 auto;
`;
export const SStretch = styled.div`
  display: flex;
  flex-flow: column;
  flex: 4 1 auto;
`;
export const SScrollStretch = SStretch.extend`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
`;



// WEBPACK FOOTER //
// ./src/components/SemifixedLayout.js